/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Schedule_EndInputs */

const vi_shop_home_schedule_end = /** @type {(inputs: Shop_Home_Schedule_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đến`)
};

/**

* @param {Shop_Home_Schedule_EndInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_schedule_end = /** @type {((inputs?: Shop_Home_Schedule_EndInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Schedule_EndInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_schedule_end(inputs)
});